import { render, staticRenderFns } from "./CommandKItemUser.vue?vue&type=template&id=dbb18372&"
import script from "./CommandKItemUser.vue?vue&type=script&lang=js&"
export * from "./CommandKItemUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports